<template>
  <div class="guideBox">
    <el-dialog
      :title="title"
      :visible.sync="showType"
      :before-close="cancelAction"
      width="820px"
    >
      <div v-if="showType">
        <div>
          DW 特供
          <ul class="search-btn">
            <li>
              <el-select
                v-model="storeType"
                size="small"
                placeholder="请选择活动区域"
                @change="getUser"
              >
                <el-option
                  label="全部人员"
                  value="0"
                />
                <el-option
                  label="按导购"
                  value="1"
                />
                <el-option
                  label="按编外"
                  value="2"
                />
              </el-select>
            </li>
            <li>
              <div class="searchBox">
                <el-input
                  v-model="searchTxt"
                  class="name-mobile-input"
                  :placeholder="params.setType == 'user' ? '请输入姓名' : '请输入门店'"
                  size="small"
                >
                  <el-select
                    slot="prepend"
                    v-model="params.setType"
                    placeholder="请选择"
                    size="small"
                    style="width: 100px"
                  >
                    <el-option
                      label="按门店"
                      value="store"
                    />
                    <el-option
                      label="按导购"
                      value="user"
                    />
                  </el-select>
                </el-input>
                <el-button
                  size="small"
                  type="primary"
                  @click="searchUser"
                >
                  搜索
                </el-button>
              </div>
            </li>
          </ul>
        </div>
        <el-row class="box">
          <el-col :span="8">
            <div class="grid-content bg-purple-dark">
              <div class="title">
                部门
              </div>
              <treeBox
                ref="treeBox"
                :disabled-node="disabledNode"
                class="department"
                :tree-data="treeData"
                :filter-text="filterText"
                :call-node="callData.storeList"
                @nodeChange="getNodeChange"
                @getIsGNode="getIsGNode"
              />
            </div>
          </el-col>
          <el-col :span="16">
            <transfer
              ref="transfer"
              class="transfer"
              :user-list="userList"
              :g-node="isGNode"
              :call-user-list="callData.userList"
              :call-store-list="callData.storeList"
              @backNode="backNode"
            />
          </el-col>
        </el-row>
        <div class="dialog_btns">
          <el-button
            class="dialog_btns-sub"
            type="primary"
            size="small"
            @click="subUserList"
          >
            确认
          </el-button>
          <el-button
            size="small"
            @click="cancelAction"
          >
            取消
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *
 * @module SpGuideBox-[导购选择器]
 * @author wzy
 * @description 导购选择器： 1.通过获取门店列表接口获取门店list 2.通过选中对应门店获取该门店下导购list
 * @see The http://salesperson.ex-sandbox.com/demo @/View/demo/index
 * @since version 1.0
 * @returns {Array}
 * @param {Boolean} showType 显隐状态
 * @param {Object} callData 回显数据
 * @param {Boolean} disabledNode 是否禁止节点选择
 * @param {String} title 弹出框title
 * 待开发
 * @param {Object} dataSource 自定义数据源注入
 * @param {Object} keysTransfer 字段映射
 */
import transfer from '@/components/guideBox/tmps/transfer'
import treeBox from '@/components/guideBox/tmps/treeBox'
import { getDepartment, getDepartmentUser, getGuideStoreList, getStoreGuide } from '@/api/component'
export default {
  name: 'DWGuideBox',
  components: {
    transfer,
    treeBox
  },
  model: {
    prop: 'showType',
    event: 'showTypeChange'
  },
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    //callData回显数据，storeList 回显门店list,userList回显人员list
    callData: {
      type: Object,
      default: () => {
        return {
          storeList: [],
          userList: []
        }
      }
    },
    title: {
      type: String,
      default: '导购选择器'
    },
    //是否禁止节点选择
    disabledNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userList: [],
      total_count: 0,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      storeType: '0',
      searchTxt: '',
      params: {
        setType: 'store',
        page: 1,
        page_size: 200,
        departmentId: 0,
        mobile: '',
        userid: '',
        name: '',
        NodesFlag: false
      },
      //treeBox props
      filterText: '', //节点筛选关键字
      sbackNode: {}, //需要撤销的节点
      isGNode: {}, //当前选中的节点
      treeData: [], //treeData
      loading: null //当前loding
    }
  },
  watch: {
    callData (nv) {
      console.log('callData', nv)
      if (nv)
        setTimeout(() => {
          this.callData.storeList &&
            this.$refs['transfer'] &&
            this.$refs['transfer'].insetGNode(this.callData.storeList)
        }, 200)
    },
    showType (nv) {}
  },
  created () {},
  mounted () {
    this.init()
    // this.CDNode2Transfer(this.callData.Nodes)
  },
  methods: {
    //showLoading
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //结束loading
    endLoading () {
      setTimeout(() => {
        this.loading.close()
        this.loading = null
      }, 500)
    },
    //回显节点至穿梭框
    CDNode2Transfer (Node) {
      // console.log('CDNode2Transfer1',Node)
      if (Node.length) {
        for (let i of Node) {
          this.$set(this, 'isGNode', i)
        }
      } else this.$set(this, 'isGNode', Node)
    },
    init () {
      this.getDepartmentData()
      this.total_count = 0
      this.userList = []
    },
    // 获取部门数据
    async getDepartmentData () {
      // let getDepartmentres = await getDepartment()
      // console.log('getDepartment',getDepartmentres)
      const datas = await getGuideStoreList({ page: 1, page_size: 100000000 })
      // console.log('datas',datas)
      let dataArray = []
      datas.forEach(function (data) {
        let parentid = data.parentid
        if (parentid == 0) {
          let objTemp = {
            id: data.id,
            name: data.name,
            order: data.order,
            parentid: parentid
          }
          dataArray.push(objTemp)
        }
      })
      const newdata = this.data2treeDG(datas, dataArray)
      this.treeData = newdata
    },
    // 数据格式转换
    data2treeDG (datas, dataArray) {
      dataArray.forEach((v) => {
        let childrenArray = []
        let Id = v.id
        datas.forEach((item) => {
          if (item.parentid == Id) {
            //判断是否为儿子节点
            let objTemp = {
              id: item.id,
              name: item.name,
              order: item.order,
              parentid: item.parentid
            }
            childrenArray.push(objTemp)
          }
        })
        v.children = childrenArray
        if (childrenArray.length > 0) {
          //有儿子节点则递归
          this.data2treeDG(datas, childrenArray)
        }
      })
      this.setTree = dataArray
      return dataArray
    },
    // 获取部门用户列表
    async getUser () {
      this.openFullScreen()
      let p = { ...this.params }
      p.store_id = p.departmentId //兼容参数
      p.store_name = p.departmentId //兼容参数
      p.employee_status = this.storeType //导购类型
      p.salesperson_name = p.setType == 'user' ? this.searchTxt : ''
      await getStoreGuide(p).then((res) => {
        this.userList = p.NodesFlag
          ? []
          : res.list.map((d) => {
              d.fid = p.departmentId
              return d
            })
        // console.log('this.userList', this.userList)
        this.total_count = res.total_count
        this.params.NodesFlag && this.$set(this.isGNode, 'total_count', res.total_count)
        this.endLoading()
      })
    },
    // 关闭模态框
    cancelAction () {
      // this.$parent.showBox = false
      this.runParentHandle()
      this.$emit('showTypeChange', false)
    },
    //获取用户点击节点
    getNodeChange (Node) {
      // console.log('getNodeChange',Node)
      this.params.departmentId = Node.id
      this.params.NodesFlag = false
      this.getUser()
    },
    //获取用户当前 check了哪些节点
    getIsGNode (Node) {
      this.isGNode = JSON.parse(JSON.stringify(Node))
      if (Node.id == this.params.departmentId) this.userList = []
      this.params.departmentId = Node.id
      this.params.NodesFlag = true
      this.getUser()
    },
    // 搜索员工列表
    searchUser () {
      if (this.params.setType == 'store') {
        this.filterText = this.searchTxt
        return this.setCheckedNodes()
      }
      this.params.name = this.searchTxt
      this.params.page = 1
      this.getUser()
    },
    // 部门搜索
    setCheckedNodes () {
      this.$refs.tree && this.$refs.tree.filter(this.filterText)
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    //撤销节点选择
    backNode (Node) {
      // console.log('index-backNode',Node)
      let VMTD = this.$refs.treeBox.VMTreeData
      this.$refs.treeBox.unCheckedNode(VMTD, Node)
    },
    //提交数据
    subUserList () {
      let userList = this.$refs['transfer'].getUserList()
      this.$emit('getUserList', userList)
      this.Sp_getGuideData(userList)
      this.cancelAction()
    }
  }
}
</script>
<style lang="scss" src="@/components/guideBox/tmps/index.scss" scoped></style>
<style lang="scss" scoped>
.guideBox {
  .box {
    border: 1px solid #dcdfe6;
    padding: 20px 0 20px 20px;
    border-radius: 5px;
    height: 520px;
  }
  .searchBox {
    display: flex;
  }
  .department {
    height: 420px;
    overflow: auto;
  }
  .dialog_btns {
    margin-top: 20px;
    text-align: right;
    &-sub {
      margin-right: 20px;
    }
  }
  .name-mobile-input {
    width: 300px;
    .el-input {
      width: 110px;
    }
  }
  .search-fields-row {
    > div {
      margin-right: 10px;
    }
  }
}
</style>
